import { getDatabase, ref, get } from 'firebase/database';
import { auth } from '../firebase';

/**
 * Checks if the current user has admin privileges
 * @returns Promise<boolean> True if the user is an admin, false otherwise
 */
export const isUserAdmin = async (): Promise<boolean> => {
    try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
            return false;
        }

        const db = getDatabase();
        const userRef = ref(db, `users/${currentUser.uid}`);
        const snapshot = await get(userRef);

        if (!snapshot.exists()) {
            return false;
        }

        const userData = snapshot.val();
        return userData.role === 'admin';
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
}; 